export default __webpack_public_path__ + "static/keyboard-shortcuts-bddb4bedd451f85260d23bc68b356ff5.png";